import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import { EmailIcon } from '../components/Icons/Icons';
import './Auth.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    console.log('Password reset email sent to:', email);
  };

  return (
    <div className="auth-page">
      <Header />

      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>{submitted ? 'Check Your Email' : 'Forgot Password?'}</h1>
            <p>
              {submitted
                ? 'We have sent a password reset link to your email'
                : 'Enter your email to receive a password reset link'}
            </p>
          </div>

          {!submitted ? (
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email Address</label>
                <div className="input-with-icon">
                  <EmailIcon size={20} color="#636e72" />
                  <input
                    type="email"
                    placeholder="your.email@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <button type="submit" className="btn-auth-primary">
                Send Reset Link
              </button>

              <div className="auth-footer">
                <p>
                  Remember your password?{' '}
                  <button
                    type="button"
                    className="link-btn"
                    onClick={() => window.navigateTo && window.navigateTo('login')}
                  >
                    Sign In
                  </button>
                </p>
              </div>
            </form>
          ) : (
            <div className="success-message">
              <div className="success-icon">✓</div>
              <p>
                If an account exists with <strong>{email}</strong>, you will receive a password
                reset link shortly.
              </p>
              <button
                type="button"
                className="btn-auth-primary"
                onClick={() => window.navigateTo && window.navigateTo('login')}
              >
                Back to Sign In
              </button>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ForgotPassword;
